﻿export interface IAddress {
    id: string;
    partyId: string;
    streetAddressLine1: string;
    streetAddressLine2: string;
    city: string;
    county: string;
    state: string;
    zipCode: string;
}

export class Address implements IAddress{
    id: string;
    partyId: string;
    streetAddressLine1: string;
    streetAddressLine2: string;
    city: string;
    county: string;
    state: string;
    zipCode: string;
}